"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatPackageSwitch = properties => {
  const _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura,
    color = properties.color,
    paddingTopNum = properties.paddingTopNum,
    paddingBottomNum = properties.paddingBottomNum; // 第一条数据是模块名称
  const resultConfiguration = configuration.map((packageSwitchItem, indexPackage) => {
    const _packageSwitchItem$tx = packageSwitchItem.txt,
      txt = _packageSwitchItem$tx === void 0 ? '' : _packageSwitchItem$tx,
      _packageSwitchItem$bt = packageSwitchItem.btnTxt,
      btnTxt = _packageSwitchItem$bt === void 0 ? '' : _packageSwitchItem$bt,
      _packageSwitchItem$hr = packageSwitchItem.href,
      href = _packageSwitchItem$hr === void 0 ? '' : _packageSwitchItem$hr,
      _packageSwitchItem$co = packageSwitchItem.commodityObject,
      commodityObject = _packageSwitchItem$co === void 0 ? '{}' : _packageSwitchItem$co;
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
    const onCallback = function () {
      window.asyncReceiveCommodity(_objectSpread({
        href
      }, resultCommodityObject));
    };
    return _objectSpread(_objectSpread(_objectSpread({}, packageSwitchItem), resultCommodityObject), {}, {
      extendProps: {
        'report-event': 'click_packageSwitch_button',
        'report-ext1': indexPackage,
        'report-ext2': btnTxt,
        'report-ext3': href
      },
      tabExtendProps: {
        'report-event': 'click_packageSwitch_tab',
        'report-ext1': indexPackage,
        'report-ext2': txt
      },
      onCallback
    });
  });
  return {
    configuration: resultConfiguration,
    color,
    paddingTopNum,
    paddingBottomNum
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit // {(event: string) => void | Promise<void>} 监听事件
}) {
  if (Object.keys(data).length > 1) {
    const _formatPackageSwitch = formatPackageSwitch(data),
      _formatPackageSwitch$ = _formatPackageSwitch.configuration,
      configuration = _formatPackageSwitch$ === void 0 ? [] : _formatPackageSwitch$,
      color = _formatPackageSwitch.color,
      paddingTopNum = _formatPackageSwitch.paddingTopNum,
      paddingBottomNum = _formatPackageSwitch.paddingBottomNum;
    const style = (0, _componentUtils.doComponentsStyleEvent)({
      color: '',
      paddingTopNum,
      paddingBottomNum
    }); // 处理组件样式
    const bgStyle = (0, _componentUtils.doComponentsBgColorEvent)(color); // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({}, (0, _reportUtil.reportShow)(['show_packageSwitch', componentKey, '']), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      style: style
    }, /*#__PURE__*/React.createElement(_intlDesignUi.PackageSwitch, {
      configuration: configuration
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}